import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
    isAuthenticated: false,
  },
  reducers: {
    setToken: (state, action) => {
      const token = action.payload;
      console.log(token)
      state.token = token;
      state.isAuthenticated = !!token;
      Cookies.set('token', token);
    },
    clearToken: (state) => {
      Cookies.remove('token');

      state.token = null;
      state.isAuthenticated = false;
    },
  },
});

export const { setToken, clearToken } = authSlice.actions;
export const selectToken = (state) => state.auth.token;

export default authSlice.reducer;
